import { createSelector, createFeatureSelector } from '@ngrx/store';
import {IDashboardState} from "@models/iDashboardState";

export const dashboardSelector = createFeatureSelector<IDashboardState>('dashboard');
export const dashboardsSelector = createSelector(dashboardSelector, (state) => state);
export const dashboardTopAffiliatesSelector = createSelector(dashboardSelector, (state) => state.data.topAffiliates);
export const dashboardTopBannersSelector = createSelector(dashboardSelector, (state) => state.data.topBanners);
export const dashboardCommissionsSelector = createSelector(dashboardSelector, (state) => state.data.commissions);
export const dashboardGroupDetailsSelector = createSelector(dashboardSelector, (state) => state.data.groupDetails);
